import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-flex-justify-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "zzlogo"
})], -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "ZZ游戏助手域名更新提醒", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "category"
}, [/*#__PURE__*/_createElementVNode("span", null, "商户后台:"), /*#__PURE__*/_createElementVNode("span", null, "https://sh.zzyxzs.com")], -1);
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLoginStore } from '@/store/login/login';
import StorageConst from '@/consts/storage.const';
import AdenLocalStorage from '@/utils/storage.util';
export default {
  __name: 'App',
  setup(__props) {
    const loginStore = useLoginStore();
    const router = useRouter();
    let hostOrigin = ref(true);
    onMounted(() => {
      // 禁止鼠标滚轮
      if (window.location.origin.includes('zzyxzs')) {
        hostOrigin.value = false;
      } else {
        hostOrigin.value = true;
        // hostOrigin.value = false;
      }
      document.addEventListener('keydown', listen_keydown, false);
      // Chrome IE 360
      window.addEventListener('mousewheel', listen_mousewheel, {
        passive: false
      });
      // firefox
      window.addEventListener('DOMMouseScroll', listen_DOMMouseScroll, {
        passive: false
      });
      if (useRoute().path !== '/login' && loginStore.token) {
        if (useRoute().path === '/main' && loginStore.token) {
          AdenLocalStorage.clearAll();
          router.push('/login');
        }
        const type = AdenLocalStorage.get(StorageConst.STORAGE_KEY_LOGIN_TYPE);
        if (type === 'business') {
          loginStore.asst = 'asst-business-system';
          return loginStore.fetchUserPermissions();
        }
        if (type === 'staff') {
          loginStore.asst = 'asst-bar-ram-login';
          return loginStore.fetchUserPermissions();
        }
        if (type === 'chain') {
          loginStore.asst = 'asst-bar-chain-login';
          return loginStore.fetchUserPermissions();
        }
      }
      if (useRoute().path === '/main' && loginStore.token) {
        AdenLocalStorage.clearAll();
        router.push('/login');
      }
    });
    const listen_keydown = event => {
      if ((event.ctrlKey === true || event.metaKey === true) && (event.which === 61 || event.which === 107 || event.which === 173 || event.which === 109 || event.which === 187 || event.which === 189)) {
        event.preventDefault();
      }
    };
    const listen_mousewheel = event => {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    };
    const listen_DOMMouseScroll = event => {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    };
    const handlerJumpSh = () => {
      window.location.href = 'https://sh.zzyxzs.com';
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_router_view), _createVNode(_component_el_dialog, {
        modelValue: _unref(hostOrigin),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(hostOrigin) ? hostOrigin.value = $event : hostOrigin = $event),
        width: "800px",
        "modal-class": "arrange-dialog",
        "destroy-on-close": true,
        "show-close": false,
        "align-center": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        style: {
          "background-color": "#ebf0fa"
        }
      }, {
        default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3, _createElementVNode("div", {
          class: "flex-flex-justify-center"
        }, [_createElementVNode("div", {
          class: "lz-button",
          onClick: handlerJumpSh
        }, "好的")])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};